export const isNullOrUndefined = (value: any) =>
  value === null || value === undefined;
